import Vue from 'vue'

// API resources
import apiEvents from '@/api/modules/events'
import apiCustomers from '@/api/modules/customers'

// Mutations
import {
  ADD_INTERACTIONS_LIST,
  DELETE_INTERACTION,
  UPDATE_INTERACTION,
  RESET_MODULE
} from '@/store/mutation-types'

// Default state
const getDefaultState = () => ({
  list: []
})
const state = getDefaultState()

// -----------------------------------------------------------------------------

const actions = {
  fetchInteractions ({ commit }, { customerId, query }) {
    return apiCustomers.fetchInteractions(customerId, query)
      .then(data => {
        commit(ADD_INTERACTIONS_LIST, data.events)
        return Promise.resolve(data.events)
      })
  },

  addInteraction ({ dispatch }, { customerId, interaction }) {
    return apiCustomers.addInteraction(customerId, interaction)
      .then(data => {
        return Promise.resolve(data.events)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  },

  deleteInteraction ({ commit }, { interactionId }) {
    return apiEvents.deleteInteraction(interactionId)
      .then(() => {
        commit(DELETE_INTERACTION, interactionId)
        return Promise.resolve()
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },

  updateInteraction ({ commit }, { interactionId, interaction }) {
    return apiEvents.updateInteraction(interactionId, interaction)
      .then(data => {
        commit(UPDATE_INTERACTION, data.event)
        return Promise.resolve(data.event)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },

  resetState ({ commit }) {
    commit(RESET_MODULE)
  }
}

const mutations = {
  [ADD_INTERACTIONS_LIST] (state, interactions) {
    Vue.set(state, 'list', interactions)
  },

  [UPDATE_INTERACTION] (state, interaction) {
    const indexInteraction = state.list.findIndex(tab => {
      return tab.id === interaction.id
    })

    let list = state.list
    list.splice(indexInteraction, 1, interaction)

    Vue.set(state, 'list', list)
  },

  [DELETE_INTERACTION] (state, interactionId) {
    Vue.set(state, 'list', state.list.filter(interaction => interaction.id !== interactionId))
  },

  [RESET_MODULE] (state) {
    Object.assign(state, getDefaultState())
  }
}

const getters = {
  disablePin: state => {
    return state.list.filter(interaction => interaction.pinned).length > 0
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations,
  getters
})
